


















































































































































import { walletStore } from '@/stores/wallet-store'
import { Observer } from 'mobx-vue'
import { Component, Inject, Vue } from 'vue-property-decorator'
import { FarmingViewModel } from '../viewmodels/farming-viewmodel'

@Observer
@Component({
  components: {
    'select-lock-period': () => import('@/modules/sb-farm/components/select-lock-period.vue'),
    'multi-logo': () => import('@/components/multi-logo/multi-logo.vue')
  }
})
export default class StakePairCalculator extends Vue {
  @Inject() vm!: FarmingViewModel
  walletStore = walletStore
}
